"use strict";

document.addEventListener("DOMContentLoaded", () => {
    archiveSummary();
});

const archiveSummary = () => {
    const BREAKPOINT = 768;
    const summaryWrappers = document.querySelectorAll('.archive-summary');

    const resetGridStyles = (container) => {
        const items = Array.from(container.querySelectorAll('.archive-item'));
        items.forEach(item => {
            item.removeAttribute('style');
            item.classList.remove('is-active');
            const children = item.querySelectorAll('.archive-item__box, .archive-item__link');
            children.forEach(child => child.removeAttribute('style'));
        });
    };

    const calculateInnerHeight = (item, skipLink) => {
        const box = item.querySelector('.archive-item__box');
        const link = item.querySelector('.archive-item__link');

        const itemStyle = window.getComputedStyle(item);
        const boxStyle = box ? window.getComputedStyle(box) : null;
        const linkStyle = link ? window.getComputedStyle(link) : null;

        let totalHeight = 0;

        totalHeight += parseFloat(itemStyle.paddingTop) + parseFloat(itemStyle.paddingBottom);
        totalHeight += parseFloat(itemStyle.borderTopWidth) + parseFloat(itemStyle.borderBottomWidth);

        if (box && boxStyle) {
            totalHeight += box.offsetHeight;
            totalHeight += parseFloat(boxStyle.marginTop) + parseFloat(boxStyle.marginBottom);
        }

        if (!skipLink && link && linkStyle) {
            totalHeight += link.offsetHeight;
            totalHeight += parseFloat(linkStyle.marginTop) + parseFloat(linkStyle.marginBottom);
        }

        return totalHeight;
    };

    const animateAccordion = (item, willOpen) => {
        const startHeight = item.offsetHeight;
        item.style.height = `${startHeight}px`;
        item.style.overflow = 'hidden';
        item.style.transition = 'none';

        void item.offsetHeight;

        if (willOpen) {
            item.classList.add('is-active');
        } else {
            item.classList.remove('is-active');
        }

        const endHeight = calculateInnerHeight(item, willOpen);

        requestAnimationFrame(() => {
            item.style.transition = 'height 0.5s cubic-bezier(0.25, 0.8, 0.25, 1), background-color 0.5s cubic-bezier(0.25, 0.8, 0.25, 1)';
            item.style.height = `${endHeight}px`;
        });

        const onTransitionEnd = (e) => {
            if (e.target !== item || e.propertyName !== 'height') return;

            item.style.height = '';
            item.style.overflow = '';
            item.style.transition = '';

            item.removeEventListener('transitionend', onTransitionEnd);
        };

        item.addEventListener('transitionend', onTransitionEnd);
    };

    document.querySelectorAll('.archive-item, .archive-item__box, .archive-item__link').forEach(el => {
        el.removeAttribute('style');
    });

    window.addEventListener('resize', () => {
        summaryWrappers.forEach(wrapper => {
            const container = wrapper.querySelector('.summary');
            if (container) resetGridStyles(container);
        });
    });

    summaryWrappers.forEach(wrapper => {
        const container = wrapper.querySelector('.summary');
        if (!container) return;

        container.addEventListener('click', (e) => {
            const clickedItem = e.target.closest('.archive-item');
            if (!clickedItem) return;

            const clickedTrigger = e.target.closest('.archive-item__link') || e.target.closest('.btn-arrow');
            if (!clickedTrigger) return;

            e.preventDefault();

            const isDesktop = window.innerWidth >= BREAKPOINT;
            const items = Array.from(container.querySelectorAll('.archive-item'));
            const isAlreadyActive = clickedItem.classList.contains('is-active');

            if (!isDesktop) {
                items.forEach(item => {
                    if (item !== clickedItem && item.classList.contains('is-active')) {
                        animateAccordion(item, false);
                    }
                });
                animateAccordion(clickedItem, !isAlreadyActive);
                return;
            }

            const firstPositions = items.map(item => item.getBoundingClientRect());
            const firstColors = items.map(item => window.getComputedStyle(item).backgroundColor);
            const index = items.indexOf(clickedItem);

            resetGridStyles(container);

            if (!isAlreadyActive) {
                clickedItem.classList.add('is-active');
                const colIndex = index % 3;
                const currentRow = Math.floor(index / 3) + 1;

                if (colIndex === 0) {
                    clickedItem.style.gridColumn = "1 / span 2";
                    clickedItem.style.gridRow = `${currentRow} / span 2`;
                } else if (colIndex === 1) {
                    clickedItem.style.gridColumn = "2 / span 2";
                    clickedItem.style.gridRow = `${currentRow} / span 2`;
                    if (items[index - 1]) {
                        items[index - 1].style.gridColumn = "1 / span 1";
                        items[index - 1].style.gridRow = `${currentRow} / span 1`;
                    }
                } else if (colIndex === 2) {
                    clickedItem.style.gridColumn = "2 / span 2";
                    clickedItem.style.gridRow = `${currentRow} / span 2`;
                    if (items[index - 1]) {
                        items[index - 1].style.gridColumn = "1 / span 1";
                        items[index - 1].style.gridRow = `${currentRow + 1} / span 1`;
                    }
                    if (items[index - 2]) {
                        items[index - 2].style.gridColumn = "1 / span 1";
                        items[index - 2].style.gridRow = `${currentRow} / span 1`;
                    }
                }
            }

            void document.body.offsetHeight;

            const lastPositions = items.map(item => item.getBoundingClientRect());

            items.forEach((item, i) => {
                const first = firstPositions[i];
                const last = lastPositions[i];
                const startColor = firstColors[i];
                const childrenToFix = item.querySelectorAll('.archive-item__box, .archive-item__link');

                if (!first || !last) return;

                const deltaX = first.left - last.left;
                const deltaY = first.top - last.top;
                const deltaW = first.width / last.width;
                const deltaH = first.height / last.height;
                const isTarget = (item === clickedItem);

                if (Math.abs(deltaX) > 0 || Math.abs(deltaY) > 0 || deltaW !== 1 || deltaH !== 1 || isTarget) {
                    item.style.transition = 'none';
                    item.style.transformOrigin = 'top left';
                    item.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(${deltaW}, ${deltaH})`;
                    item.style.backgroundColor = startColor;

                    const scaleInvertW = deltaW !== 0 ? 1 / deltaW : 1;
                    const scaleInvertH = deltaH !== 0 ? 1 / deltaH : 1;

                    childrenToFix.forEach(child => {
                        child.style.transition = 'none';
                        child.style.transformOrigin = 'top left';
                        child.style.transform = `scale(${scaleInvertW}, ${scaleInvertH})`;
                    });

                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            item.style.transition = 'transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1), background-color 0.5s cubic-bezier(0.25, 0.8, 0.25, 1)';
                            item.style.transform = '';
                            item.style.backgroundColor = '';

                            childrenToFix.forEach(child => {
                                child.style.transition = 'transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1)';
                                child.style.transform = '';
                            });
                        });
                    });
                }
            });
        });
    });

    const summaries = document.querySelectorAll('.archive-summary');
    summaries.forEach(summaryWrapper => {
        const filters = summaryWrapper.querySelectorAll('.filters input');
        const summary = summaryWrapper.querySelector('.summary');
        const moreWrap = summaryWrapper.querySelector('.more');
        const moreBtn = moreWrap ? moreWrap.querySelector('.btn--more') : null;

        let localPage = 1;
        let currentCategory = '';

        const loadPosts = (isAppend = false) => {
            const formData = new FormData();
            formData.append('action', 'load_morearchive_action');
            formData.append('_wpnonce', scriptObj.nonce);
            formData.append('category', currentCategory);
            formData.append('type', summary.dataset.type);
            formData.append('perPage', summary.dataset.perpage);
            formData.append('pp', localPage);
            formData.append('lang', scriptObj.lang);

            fetch(scriptObj.ajaxurl, { method: 'POST', body: formData })
                .then(res => res.json())
                .then(data => {
                    if (isAppend) {
                        summary.insertAdjacentHTML('beforeend', data.data);
                    } else {
                        summary.innerHTML = data.data;
                    }

                    if (moreWrap) {
                        if (data.max > localPage) {
                            moreWrap.classList.remove('hidden');
                        } else {
                            moreWrap.classList.add('hidden');
                        }
                    }
                })
                .catch(err => console.error(err));
        };

        filters.forEach(input => {
            input.addEventListener('change', () => {
                localPage = 1;
                currentCategory = input.value;
                loadPosts(false);
            });
        });

        if (moreBtn) {
            moreBtn.addEventListener('click', e => {
                e.preventDefault();
                localPage++;
                loadPosts(true);
            });
        }

        const defaultChecked = summaryWrapper.querySelector('.filters input:checked');
        const urlHash = window.location.hash.replace('#', '');
        let hashInput = null;

        if (urlHash) {
            hashInput = summaryWrapper.querySelector(`.filters input[data-hash="${urlHash}"]`);
        }

        if (hashInput) {
            hashInput.click();
            setTimeout(() => {
                const rect = summaryWrapper.getBoundingClientRect();
                const offset = window.scrollY + rect.top - 120;
                window.scrollTo({ top: offset, behavior: 'smooth' });
            }, 200);
        } else if (defaultChecked) {
            currentCategory = defaultChecked.value;
            defaultChecked.click();
        }
    });
};